import { createProject } from '@pepper/utils/src/api/projects/projects'

type Args = {
  projectId: string
  projectName?: string
  verticalId: number
  projectTitle?: string
  topics: {
    title?: string
    topic_id?: string
  }[]
  verticals: VerticalObjectType[]
  companyId: string
}

/**
 * @deprecated use `generateDraftData` from `components/CreateItemModal/CreateItemModal.utils.ts`
 */
export const generateDraftData = async ({
  projectTitle,
  topics,
  companyId,
  projectId: _projectId,
  projectName,
  verticalId,
  verticals,
}: Args): Promise<any> => {
  let draftData
  let projectId

  const selectedVertical = verticals.find(v => v.id === verticalId)
  if (_projectId && _projectId !== 'new') {
    draftData = {
      project_id: _projectId,
      vertical_id: verticalId,
      project_title: projectTitle,
      assignments: topics.map(topic => ({
        assignment_title: topic.title,
        topic_id: topic.topic_id,
      })),
    }
    projectId = _projectId
  } else {
    const {
      status: _status,
      error: _error,
      data,
    } = await createProject({
      body: {
        assignments: [],
        company_id: companyId,
        project_title: projectName,
      },
    })
    if (_status !== 'ok' || data === null) {
      return { error: _error }
    }
    draftData = {
      company_id: companyId,
      project_category: selectedVertical?.category.id,
      vertical_id: verticalId,
      project_id: data.project_id,
      project_title: projectName,
      assignments: topics.map(topic => ({ assignment_title: topic })),
    }
    projectId = data.project_id
  }
  return { draftData, projectId }
}
